import { MRT_ColumnFiltersState, MRT_SortingState } from 'mantine-react-table'

type BuildSortingAndFilterParamsProps = {
  sorting: MRT_SortingState
  columnFilters: MRT_ColumnFiltersState
  tagSources?: string[]
  descriptionSearch?: string
  trackingIds?: string
}

export const buildSortingAndFilterParams = ({
  sorting,
  columnFilters,
  tagSources,
  descriptionSearch,
  trackingIds
}: BuildSortingAndFilterParamsProps) => {
  const { id, desc } = sorting[0] || { id: '', desc: false }
  const sortProp = id.replace(' ', '_').toLowerCase()
  const sortOrder = desc ? 'desc' : 'asc'

  const hasSort = sortProp && sortOrder

  const timestampFilter = columnFilters.find(
    (filter) => filter.id === 'timestamp'
  ) || { value: [] }

  const [startDate, endDate] = timestampFilter.value as (Date | '')[]

  let dayAfterEndDate

  if (endDate) {
    dayAfterEndDate = new Date(endDate.getTime())
    dayAfterEndDate.setDate(endDate.getDate() + 1)
  }

  // The API supports multiple devices/cameras, but the FE filter allows selecting only one at a time
  const deviceId = columnFilters.find(
    (filter) => filter.id === 'metadata.device_id'
  )?.value as string | undefined

  const cameraId = columnFilters.find(
    (filter) => filter.id === 'metadata.camera_id'
  )?.value as string | undefined

  const detection = columnFilters.find((filter) => filter.id === 'detections')
    ?.value as string | undefined

  const roiName = columnFilters.find((filter) => filter.id === 'roiName')
    ?.value as string | undefined

  const classifierTags = columnFilters.find(
    (filter) => filter.id === 'classifier_tags'
  )?.value as string[] | undefined

  const nonClassifierTags = columnFilters.find(
    (filter) => filter.id === 'other_tags'
  )?.value as string[] | undefined

  const tags = [...(classifierTags ?? []), ...(nonClassifierTags ?? [])].join(
    ','
  )

  const measurementId = columnFilters.find(
    (filter) => filter.id === 'measurement_id'
  )?.value as string | undefined

  const ocrSearch = columnFilters.find((filter) => filter.id === 'ocr_results')
    ?.value as string | undefined

  const machineCodeSearch = columnFilters.find(
    (filter) => filter.id === 'machine_code_results'
  )?.value as string | undefined

  const queryParams = {
    ...(hasSort && { sort_property: sortProp }),
    ...(hasSort && { sort_order: sortOrder }),
    ...(startDate && { start_date: startDate }),
    ...(dayAfterEndDate && { end_date: dayAfterEndDate }),
    ...(deviceId && { devices: deviceId }),
    ...(cameraId && { stream_ids: cameraId }),
    ...(detection && { detections: detection }),
    ...(roiName && { roi_line_names: roiName }),
    ...(tags && { tags }),
    ...(tagSources?.length && { tag_sources: tagSources.join(',') }),
    ...(measurementId && { measurement_id: measurementId }),
    ...(ocrSearch && { ocr_search: ocrSearch }),
    ...(machineCodeSearch && { machine_code_search: machineCodeSearch }),
    ...(descriptionSearch && { description_search: descriptionSearch }),
    ...(trackingIds && { tracking_ids: trackingIds })
  }

  return queryParams
}
